<template>
    <div class="ticket-images-layout">
        <div class="logo">
            <img src="@/assets/images/logo.png" class="w-100 mb-4" />
        </div>

        <div v-if="loading" class="text-center text-muted">Loading images...</div>

        <div v-else-if="error" class="text-center text-muted">
            This link is no longer available. Please get in touch with the lab.
        </div>

        <div v-else>
            <div class="bg-white mb-3">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h1 class="h4 mb-0">View Images - {{ patientName }}</h1>
                    </div>
                </div>
            </div>

            <div v-if="filesData && filesData.length" style="clear:both;">
                <div class="row files-row mt-4">
                    <h2 class="h5 mt-3 mb-3 page-section-heading">Uploaded Files</h2>
                    <LightboxGallery :files="filesData" />
                </div>
            </div>

            <div v-else class="content-row">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="text-left">There are no images to show for this order.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "@/services/api";
    import LightboxGallery from '@/components/LightboxGallery.vue';

    export default {
        name: "TicketImages",
        props: {
            code: {
                required: true
            }
        },
        data() {
            return {
                orderNumber: null,
                patientName: '',
                filesData: null,
                loading: true,
                error: false,
            };
        },
        components: {
            LightboxGallery,
        },
        mounted () {
            this.fetchImages();
        },
        methods: {
            fetchImages: function() {
                api
                .get('/api/v1/tickets/access/' + this.code + '/images')
                .then((response) => {
                    this.orderNumber = response.data.order_number;
                    this.patientName = response.data.patient_name;
                    this.filesData = response.data.files;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
            },
        },
    }
</script>

<style scoped lang="scss">
    .ticket-images-layout
    {
        max-width: 800px;
        width: 100%;
        margin: auto;
        margin-top: 5vh;
        margin-bottom: 2rem;
    }

    .ticket-images-layout .logo
    {
        max-width: 400px;
        width: 100%;
        margin: auto;
        margin-top: 10vh;
        margin-bottom: 2rem;
    }
</style>
